import { createSlice } from '@reduxjs/toolkit';
import {DEFAULT_TAB} from "../../components/IDG/RestaurantSearch/SearchTabs/SearchTabs";
import {BASE_MARKER_HEIGHT, BASE_MARKER_WIDTH} from "../../components/IDG/MapMarker/MapMarker";
import {BASE_RESTAURANT_MAP_POPUP_OFFSET} from "../../components/IDG/RestaurantMapPopup/RestaurantMapPopup";

const initialState = {
    restaurants: [],
    categories: [],
    selectedSearchTab: DEFAULT_TAB,
    nameSearchQuery: null,
    nameSearchResults: null,
    geoSearchQuery: null,
    currentMapBounds: null,
    selectedFilters: {
        recommended: false,
        category: null
    },
    clickedRestaurant: null,
    mapObjectsSize: {
        markerWidth: BASE_MARKER_WIDTH,
        markerHeight: BASE_MARKER_HEIGHT,
        restaurantMapPopupOffsset: BASE_RESTAURANT_MAP_POPUP_OFFSET
    }
};

export const restaurantSearchSlice = createSlice({
    name: 'restaurantSearch',
    initialState: initialState,
    reducers: {
        setRestaurants(state, action) {
            state.restaurants = action.payload;
        },
        setCategories(state, action) {
            state.categories = action.payload;
        },
        setNameSearchQuery(state, action) {
            state.nameSearchQuery = action.payload;
        },
        resetNameSearchQuery(state, action) {
            state.nameSearchQuery = initialState.nameSearchQuery;
        },
        setNameSearchResults(state, action) {
            state.nameSearchResults = action.payload;
        },
        resetNameSearchResults(state, action) {
            state.nameSearchResults = initialState.nameSearchResults;
        },
        setGeoSearchQuery(state, action) {
            state.geoSearchQuery = action.payload;
        },
        resetGeoSearchQuery(state, action) {
            state.geoSearchQuery = initialState.geoSearchQuery;
        },
        setSelectedSearchTab(state, action) {
            state.selectedSearchTab = action.payload;
        },
        setSelectedFilters(state, action) {
            state.selectedFilters = action.payload;
        },
        resetSelectedFilters(state, action) {
            state.selectedFilters = initialState.selectedFilters;
        },
        setSelectedRecommendedFilter(state, action) {
            state.selectedFilters.recommended = !!action.payload;   //
        },
        setSelectedCategoryFilter(state, action) {
            state.selectedFilters.category = action.payload;
        },
        setCurrentMapBounds(state, action) {
            state.currentMapBounds = action.payload;
        },
        resetCurrentMapBounds(state, action) {
            state.currentMapBounds = initialState.currentMapBounds;
        },
        setClickedRestaurant(state, action) {
            state.clickedRestaurant = action.payload;
        },
        resetClickedRestaurant(state, action) {
            state.clickedRestaurant = initialState.clickedRestaurant;
        },
        setMapObjectsSize(state, action) {
            state.mapObjectsSize = action.payload;
        },
        resetMapObjectsSize(state, action) {
            state.mapObjectsSize = initialState.mapObjectsSize;
        }
    },
});

export const getRestaurants = state => state.restaurantSearch.restaurants;
export const getCategories = state => state.restaurantSearch.categories;
export const getNameSearchQuery = state => state.restaurantSearch.nameSearchQuery;
export const getNameSearchResults = state => state.restaurantSearch.nameSearchResults;
export const getGeoSearchQuery = state => state.restaurantSearch.geoSearchQuery;
export const getSelectedSearchTab = state => state.restaurantSearch.selectedSearchTab;
export const getSelectedFilters = state => state.restaurantSearch.selectedFilters;
export const getCurrentMapBounds = state => state.restaurantSearch.currentMapBounds;
export const getClickedRestaurant = state => state.restaurantSearch.clickedRestaurant;
export const getMapObjectsSize = state => state.restaurantSearch.mapObjectsSize;

export const {
    setRestaurants,
    setCategories,
    setNameSearchQuery,
    resetNameSearchQuery,
    setNameSearchResults,
    resetNameSearchResults,
    setGeoSearchQuery,
    resetGeoSearchQuery,
    setSelectedSearchTab,
    setSelectedFilters,
    setSelectedRecommendedFilter,
    setSelectedCategoryFilter,
    resetSelectedFilters,
    setCurrentMapBounds,
    resetCurrentMapBounds,
    setClickedRestaurant,
    resetClickedRestaurant,
    setMapObjectsSize,
    resetMapObjectsSize
} = restaurantSearchSlice.actions;

export default restaurantSearchSlice.reducer;

